var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H4L0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H16C16.2652 0 16.5196 0.105357 16.7071 0.292893C16.8946 0.48043 17 0.734784 17 1V12C17 12.2652 16.8946 12.5196 16.7071 12.7071C16.5196 12.8946 16.2652 13 16 13ZM21 7V21L17 17H6C5.73478 17 5.48043 16.8946 5.29289 16.7071C5.10536 16.5196 5 16.2652 5 16V15H19V6H20C20.2652 6 20.5196 6.10536 20.7071 6.29289C20.8946 6.48043 21 6.73478 21 7ZM6.19 2C5.32 2 4.62 2.2 4.08 2.59C3.56 3 3.3 3.57 3.31 4.36L3.32 4.39H5.25C5.26 4.09 5.35 3.86 5.53 3.7C5.71517 3.54644 5.9495 3.46479 6.19 3.47C6.5 3.47 6.76 3.57 6.94 3.75C7.12 3.94 7.2 4.2 7.2 4.5C7.2 4.82 7.13 5.09 6.97 5.32C6.83 5.55 6.62 5.75 6.36 5.91C5.85 6.25 5.5 6.55 5.31 6.82C5.11 7.08 5 7.5 5 8H7C7 7.69 7.04 7.44 7.13 7.26C7.22 7.08 7.39 6.9 7.64 6.74C8.09 6.5 8.46 6.21 8.75 5.81C9.04 5.41 9.19 5 9.19 4.5C9.19 3.74 8.92 3.13 8.38 2.68C7.85 2.23 7.12 2 6.19 2ZM5 9V11H7V9H5ZM11 11H13V9H11V11ZM11 2V8H13V2H11Z",
    fill: "#17282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.39861dcad38452b641796547dfebaacb.svg";
export { ForwardRef as ReactComponent };